export default __webpack_public_path__ + "static/media/seguridade-banner-mobile-backgrund.04581c32.png";